import { render, staticRenderFns } from "./VulnerabilityBreadcrumbs.vue?vue&type=template&id=6d046e0c"
import script from "./VulnerabilityBreadcrumbs.vue?vue&type=script&setup=true&lang=ts"
export * from "./VulnerabilityBreadcrumbs.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports